import { render, staticRenderFns } from "./PremiumSubscribersCard.vue?vue&type=template&id=c981179c&scoped=true"
import script from "./PremiumSubscribersCard.vue?vue&type=script&lang=js"
export * from "./PremiumSubscribersCard.vue?vue&type=script&lang=js"
import style0 from "./PremiumSubscribersCard.vue?vue&type=style&index=0&id=c981179c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c981179c",
  null
  
)

export default component.exports